import React from 'react';

import { Badge } from '@rtkwlf/fenrir-react';
import { useTranslation } from 'react-i18next';

export const ComingSoonBadge = () => {
  const { t } = useTranslation();

  return (
    <Badge.Root appearance="info">
      <Badge.Text>{t('ui:comingSoon')}</Badge.Text>
    </Badge.Root>
  );
};
